import { render } from "./TrafficLights.vue?vue&type=template&id=726f76d8"
import script from "./TrafficLights.vue?vue&type=script&lang=js"
export * from "./TrafficLights.vue?vue&type=script&lang=js"

import "./TrafficLights.vue?vue&type=style&index=0&id=726f76d8&lang=scss"

import exportComponent from "C:\\Users\\shikarno\\Desktop\\Projects\\traffic-lights\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__